
import React from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { Text } from 'office-ui-fabric-react';

import OpenButton from '../common/OpenButton';

const classNames = mergeStyleSets({
    label: {
        borderBottom: '1px solid black'
    },
    container: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '1em 0em'
    },
    content: {
        paddingTop: 8,
        paddingButton: 8
    },
    requirements: {
        paddingTop: 8,
        paddingButton: 8
    }
});

const SelectFileForImportEnabled = ({
    acceptFileType,
    canContinue,
    loading,
    onContinueClick,
    onUploadFile,
    readedItemsCount
}) => {

    const handleContinueClick = () => {
        if (onContinueClick) {
            onContinueClick();
        }
    }

    const renderContinue = () => {
        return (
            <PrimaryButton
                onClick={handleContinueClick}
                text="Pokračovat"
            />
        )
    }

    const renderLoading = () => {
        return <div>Načítám obsah zadaného souboru...</div>
    }

    const renderFileContent = () => {
        let message = '';
        if (readedItemsCount > 0) {
            message = `Počet načtených úseků mezí ze zadaného souboru: ${readedItemsCount}`;
        }
        if (readedItemsCount === 0) {
            message = `Zadaný soubor neobsahuje žádné úseky mezí`;
        }

        return (
            <div className={classNames.content}>{message}</div>
        )
    }

    const renderFileRequirements = () => {
        return (
            <div className={classNames.requirements}>
                <div>Požadavky na načítaný soubor:</div>
                <div>- musí obsahovat pouze linie, které představují jednotlivé úseky mezí</div>
                <div>- každá linie musí mít vyplněný atribut "id_usek"</div>
                <div>- musí být v souřadnicovém systému "S-JTSK" (EPSG:5514)</div>
                <div>- podporovaný formát je GeoJSON</div>
            </div>
        );
    }

    const uploadIco = { iconName: 'Upload' };

    return (
        <Stack horizontal className={classNames.container}>
            <Stack.Item>
                <Text>Zadání souboru s úseky mezí: </Text>
            </Stack.Item>
            <Stack.Item>
                <OpenButton
                    iconProps={uploadIco}
                    acceptFileType={acceptFileType}
                    onProcessOpenFile={onUploadFile}
                    text="Načíst soubor s úseky mezí"
                />
                {loading && renderLoading()}
                {renderFileContent()}
                {renderFileRequirements()}
                {canContinue && renderContinue()}
            </Stack.Item>
        </Stack>
    );
}

export default SelectFileForImportEnabled;
